export const getColorTemplate = (
  templateSettings,
  activeTemplateName,
  activeTemplate,
) => {
  return templateSettings && templateSettings[activeTemplateName]?.colorPalette
    ? templateSettings[activeTemplateName].colorPalette.split('|')
    : activeTemplate?.colorPalette[0];
};
